/**
 * /privacy — tüm yerel ayarlarda aynı İngilizce metin (statik, güvenilir HTML).
 */
export const LEGAL_PRIVACY_HTML = `
<h2 class="wedy-legal__h2">Introduction</h2>
<p>We respect your privacy and are committed to protecting your personal data. This privacy policy explains how we handle any information collected while you use our Wedding App.</p>

<h2 class="wedy-legal__h2">Information We Collect</h2>
<p>Our app collects the following information:</p>
<ul class="wedy-legal__list">
  <li>User profile information (names of bride and groom)</li>
  <li>Wedding details (date, venue, timeline)</li>
  <li>Contact information</li>
  <li>RSVP responses from guests</li>
  <li>Device information for app functionality</li>
</ul>

<h2 class="wedy-legal__h2">How We Use Your Information</h2>
<p>We use the collected information to:</p>
<ul class="wedy-legal__list">
  <li>Create and maintain your wedding website</li>
  <li>Process and store RSVP responses</li>
  <li>Share wedding details with your guests</li>
  <li>Improve app functionality and user experience</li>
  <li>Provide customer support</li>
</ul>

<h2 class="wedy-legal__h2">Data Storage and Security</h2>
<p>We implement appropriate security measures to protect your personal information. Your data is stored securely and only accessed when necessary for providing our services.</p>

<h2 class="wedy-legal__h2">Sharing Your Information</h2>
<p>Your wedding website information is only shared with the guests you choose to invite. We do not sell or share your personal information with third parties for marketing purposes.</p>

<h2 class="wedy-legal__h2">Your Rights</h2>
<p>You have the right to:</p>
<ul class="wedy-legal__list">
  <li>Access your personal data</li>
  <li>Request correction of your data</li>
  <li>Request deletion of your data</li>
  <li>Control who can view your wedding website</li>
</ul>

<h2 class="wedy-legal__h2">Updates to Privacy Policy</h2>
<p>We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page.</p>

<h2 class="wedy-legal__h2">Contact Us</h2>
<p>If you have any questions about this privacy policy or our practices, please contact us at <a class="wedy-legal__link" href="mailto:wedding@mobyte.com.tr">wedding@mobyte.com.tr</a>.</p>
`.trim();
